export default __webpack_public_path__ + "static/media/strikepay_Mark_RGB_White.02d929bb.png";